var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 251.193,
    height: 168.554
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settled_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Rectangle_281",
    "data-name": "Rectangle 281",
    fill: "none",
    stroke: "#0eb3f2",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M0 0h67v67H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Holder_-_Settled_Empty",
    "data-name": "Holder - Settled Empty",
    transform: "translate(-59 -315.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Group_656",
    "data-name": "Group 656",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Group_2300",
    "data-name": "Group 2300",
    transform: "translate(14 -10)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "settled_svg__Rectangle_282",
    "data-name": "Rectangle 282",
    width: 180,
    height: 90,
    rx: 10,
    transform: "translate(105 345)",
    fill: "#2b3236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_12",
    "data-name": "Line 12",
    fill: "none",
    stroke: "#4f5558",
    strokeWidth: 1,
    d: "M105 405h180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_188",
    "data-name": "Line 188",
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 367h49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_189",
    "data-name": "Line 189",
    fill: "none",
    stroke: "#4f5558",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 382h113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Semicircle",
    transform: "translate(105 361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Rectangle_51",
    "data-name": "Rectangle 51",
    d: "M.784 0h11.108A14.108 14.108 0 0126 14.108 14.892 14.892 0 0111.108 29H.784A.784.784 0 010 28.216V.784A.784.784 0 01.784 0z",
    fill: "#10181c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Icon_-_Bet_Multi",
    "data-name": "Icon - Bet Multi",
    transform: "translate(109.159 367.406)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5542",
    "data-name": "Path 5542",
    d: "M12.4 15.309V1.721a.971.971 0 00-.97-.971H1.72a.971.971 0 00-.97.971v13.588l3.321-1.941 2.5 1.941 2.5-1.941z",
    transform: "translate(-.232 -.232)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5543",
    "data-name": "Path 5543",
    d: "M5.2 9.673a.243.243 0 110-.485",
    transform: "translate(-1.534 -2.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5544",
    "data-name": "Path 5544",
    d: "M5.3 9.673a.243.243 0 100-.485",
    transform: "translate(-1.644 -2.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5545",
    "data-name": "Path 5545",
    d: "M5.2 13.891a.243.243 0 110-.485",
    transform: "translate(-1.534 -4.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5546",
    "data-name": "Path 5546",
    d: "M5.3 13.891a.243.243 0 100-.485",
    transform: "translate(-1.644 -4.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5547",
    "data-name": "Path 5547",
    d: "M5.2 5.454a.243.243 0 110-.485",
    transform: "translate(-1.534 -1.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5548",
    "data-name": "Path 5548",
    d: "M5.3 5.454a.243.243 0 100-.485",
    transform: "translate(-1.644 -1.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_957",
    "data-name": "Line 957",
    transform: "translate(6.153 3.672)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h3.338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_958",
    "data-name": "Line 958",
    transform: "translate(6.153 6.583)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h3.338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_959",
    "data-name": "Line 959",
    transform: "translate(6.153 9.495)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h3.338"
  })), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Rectangle_1021",
    "data-name": "Rectangle 1021",
    d: "M12 0h48.429A2.571 2.571 0 0163 2.571v18.858A2.571 2.571 0 0160.429 24H12A12 12 0 010 12 12 12 0 0112 0z",
    transform: "translate(225 392.583)",
    fill: "#0eb3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_960",
    "data-name": "Line 960",
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeWidth: 6,
    opacity: 0.5,
    d: "M254 404.583h23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Group_2299",
    "data-name": "Group 2299",
    transform: "translate(233.963 399.846)",
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "settled_svg__Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 3.052,
    cy: 3.052,
    r: 3.052,
    transform: "translate(.349 .349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_346",
    "data-name": "Line 346",
    transform: "translate(5.667 5.609)",
    d: "M0 0l3.458 3.516"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Group_653",
    "data-name": "Group 653",
    transform: "translate(-16 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "settled_svg__Rectangle_282-2",
    "data-name": "Rectangle 282",
    width: 180,
    height: 90,
    rx: 10,
    transform: "translate(105 345)",
    fill: "#2b3236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_12-2",
    "data-name": "Line 12",
    fill: "none",
    stroke: "#4f5558",
    strokeWidth: 1,
    d: "M105 405h180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_188-2",
    "data-name": "Line 188",
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 367h49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_189-2",
    "data-name": "Line 189",
    fill: "none",
    stroke: "#4f5558",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M148 382h113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Semicircle-2",
    "data-name": "Semicircle",
    transform: "translate(105 361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Rectangle_51-2",
    "data-name": "Rectangle 51",
    d: "M.784 0h11.108A14.108 14.108 0 0126 14.108 14.892 14.892 0 0111.108 29H.784A.784.784 0 010 28.216V.784A.784.784 0 01.784 0z",
    fill: "#10181c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Icon_-_Bet_Multi-2",
    "data-name": "Icon - Bet Multi",
    transform: "translate(109.159 367.406)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5542-2",
    "data-name": "Path 5542",
    d: "M12.4 15.309V1.721a.971.971 0 00-.97-.971H1.72a.971.971 0 00-.97.971v13.588l3.321-1.941 2.5 1.941 2.5-1.941z",
    transform: "translate(-.232 -.232)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5543-2",
    "data-name": "Path 5543",
    d: "M5.2 9.673a.243.243 0 110-.485",
    transform: "translate(-1.534 -2.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5544-2",
    "data-name": "Path 5544",
    d: "M5.3 9.673a.243.243 0 100-.485",
    transform: "translate(-1.644 -2.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5545-2",
    "data-name": "Path 5545",
    d: "M5.2 13.891a.243.243 0 110-.485",
    transform: "translate(-1.534 -4.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5546-2",
    "data-name": "Path 5546",
    d: "M5.3 13.891a.243.243 0 100-.485",
    transform: "translate(-1.644 -4.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5547-2",
    "data-name": "Path 5547",
    d: "M5.2 5.454a.243.243 0 110-.485",
    transform: "translate(-1.534 -1.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_5548-2",
    "data-name": "Path 5548",
    d: "M5.3 5.454a.243.243 0 100-.485",
    transform: "translate(-1.644 -1.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_957-2",
    "data-name": "Line 957",
    transform: "translate(6.153 3.672)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h3.338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_958-2",
    "data-name": "Line 958",
    transform: "translate(6.153 6.583)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h3.338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_959-2",
    "data-name": "Line 959",
    transform: "translate(6.153 9.495)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h3.338"
  })), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Rectangle_1021-2",
    "data-name": "Rectangle 1021",
    d: "M12 0h48.429A2.571 2.571 0 0163 2.571v18.858A2.571 2.571 0 0160.429 24H12A12 12 0 010 12 12 12 0 0112 0z",
    transform: "translate(225 392.583)",
    fill: "#0eb3f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_960-2",
    "data-name": "Line 960",
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeWidth: 6,
    opacity: 0.5,
    d: "M254 404.583h23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Group_2299-2",
    "data-name": "Group 2299",
    transform: "translate(233.963 399.846)",
    fill: "none",
    stroke: "#10181c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "settled_svg__Ellipse_155-2",
    "data-name": "Ellipse 155",
    cx: 3.052,
    cy: 3.052,
    r: 3.052,
    transform: "translate(.349 .349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_346-2",
    "data-name": "Line 346",
    transform: "translate(5.667 5.609)",
    d: "M0 0l3.458 3.516"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Icon_-_Search_Large",
    "data-name": "Icon - Search Large",
    transform: "translate(59 425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Group_650",
    "data-name": "Group 650",
    transform: "translate(0 -.001)",
    clipPath: "url(#settled_svg__clip-path)",
    fill: "none",
    stroke: "#0eb3f2",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "settled_svg__Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 22.47,
    cy: 22.47,
    r: 22.47,
    transform: "translate(1.404 1.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Line_186",
    "data-name": "Line 186",
    transform: "translate(39.761 39.762)",
    d: "M0 0l26.245 26.245"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "settled_svg__Group_657",
    "data-name": "Group 657",
    transform: "translate(281.5 315.446)",
    fill: "#737c81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_3941",
    "data-name": "Path 3941",
    d: "M26.577 30.952l4.273-.252a.344.344 0 00.142-.647l-3.775-2.019a2.146 2.146 0 01-1.13-1.767L25.839 22a.344.344 0 00-.647-.142l-2.019 3.772a2.145 2.145 0 01-1.767 1.13l-4.273.249a.344.344 0 00-.142.647l3.775 2.019a2.145 2.145 0 011.13 1.767l.249 4.273a.344.344 0 00.647.142l2.019-3.774a2.146 2.146 0 011.767-1.13",
    transform: "translate(-9.85 -12.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_3942",
    "data-name": "Path 3942",
    d: "M6.226 4.639l2.2-1.345a.207.207 0 00-.108-.383H5.743a1.292 1.292 0 01-1.1-.616L3.293.1a.207.207 0 00-.383.108v2.575a1.291 1.291 0 01-.616 1.1L.1 5.229a.207.207 0 00.108.383h2.574a1.289 1.289 0 011.1.616l1.345 2.2a.207.207 0 00.383-.108V5.745a1.292 1.292 0 01.616-1.1",
    transform: "translate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_3943",
    "data-name": "Path 3943",
    d: "M59.881 19.513l1.6 1.072a.155.155 0 00.227-.194L60.9 18.64a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.075.942l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(-33.384 -9.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_3944",
    "data-name": "Path 3944",
    d: "M6.109 75.1l1.6 1.072a.155.155 0 00.227-.194l-.808-1.751a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.073.936l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(2.127 -31.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_3945",
    "data-name": "Path 3945",
    d: "M59.881 19.513l1.6 1.072a.155.155 0 00.227-.194L60.9 18.64a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.075.942l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(-243.384 1.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settled_svg__Path_3946",
    "data-name": "Path 3946",
    d: "M59.881 19.513l1.6 1.072a.155.155 0 00.227-.194L60.9 18.64a.968.968 0 01.074-.942l1.072-1.6a.155.155 0 00-.194-.227l-1.751.807a.965.965 0 01-.942-.074l-1.6-1.072a.155.155 0 00-.227.194l.808 1.751a.967.967 0 01-.075.942l-1.072 1.6a.155.155 0 00.194.227l1.751-.807a.965.965 0 01.942.074",
    transform: "translate(-163.384 130.915)"
  })))));
}
export default __webpack_public_path__ + "static/settled.664cf881.svg";
export { SvgSettled as ReactComponent };